import React from 'react';
import { useQuery } from 'react-apollo';
import gql from 'graphql-tag';

const useUserCredits = () => {
  const [creditsAvailable, setCreditsAvailable] = React.useState(0);
  const {
    loading: isFetchingUserCredits,
    data: userCreditsData,
  } = useQuery(gql`
    query userCredits {
      me {
        crehanaCredit {
          creditAvailable
        }
      }
    }
  `);

  React.useEffect(() => {
    if (!isFetchingUserCredits && userCreditsData) {
      const creditAvailable =
        userCreditsData.me && userCreditsData.me.crehanaCredit
          ? userCreditsData.me.crehanaCredit.creditAvailable
          : 0;

      setCreditsAvailable(creditAvailable);
    }
  }, [isFetchingUserCredits, userCreditsData]);

  return { creditsAvailable, isFetchingUserCredits };
};

export default useUserCredits;
